import React, { useEffect } from 'react'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRegistroGuest } from 'hooks/useLogin'
import { useHistory, useLocation } from 'react-router-dom';
import './style.sass'

import { Header } from 'pages/Header'
import ErrorType from 'pages/Error/ErrorType'

// import RegistroForm from 'components/LoginRegistro/Registro'
import Loading from 'components/Loading'
import { ErrorBoundary } from 'components/Error/ErrorBoundary'
// import RegistroFormGuest from 'components/LoginRegistro/RegistroGuest'


export default function BeforeGuest() {
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const redirect = searchParams.get('redirect');


    const invitado = () => {
        history.push(`/guest?redirect=${redirect}`);
    }

    const user = () => {
        history.push(`/login?redirect=${redirect}`);
    }

    const {
        dataRegistro,
        reciveDataRegistro,
        // reciveDataRegistroFacebook
    } = useRegistroGuest()

    const { isMobile } = useIsMobile()
    // const desktopView = () => document.querySelector('#root').classList.add('desktopView')

    useEffect(() => {
        if (isMobile) {
            if (isMobile === 'desktop') {
                document.querySelector('#root').classList.add('desktopView')
            }
        }
    }, [isMobile])


    return (
        <>
            { dataRegistro.loading && <Loading />}
            <Header type='simple' pageClass={isMobile !== 'desktop' ? 'hidden' : 'registroHeader'} />
            <main>
                {dataRegistro.statusCode !== 500
                    ?
                        <>
                            {!dataRegistro.isLoged &&
                                <section className="loginRegistroPage">
                                    <div className="container">
                                        {// isMobile === 'desktop'
                                            // ?
                                                // <h1 className="titleRegistro">Para comprar como invitado, compártenos tu correo electrónico y número de telefono</h1>
                                            // :
                                                <div className="loginPage form-horizontal contenidoCentrado">
                                                    <button className="btn rojo btn-block btn-lg primaryButton" onClick={invitado}>Comprar como invitado</button>
                                                    <button className="btn rojo btn-block btn-lg secondaryButton" onClick={user}>Ya estoy registrado en Sears</button>
                                                </div>
                                        }
                                    </div>
                                </section>
                            }
                        </>
                    :
                        <>
                            <ErrorBoundary>
                                <ErrorType
                                    codeStatus={500}
                                    errorText=""
                                />
                            </ErrorBoundary>
                        </>
                }
            </main>
        </>
    )
}